<template>
    <div class="app-adj-info" >     
        <div class="app-adj-info" v-if="adjudicationLicenseInfo"> 
            <div class="app-adj-info-row" v-if="adjudicationLicenseInfo.adjudicationLicenseInformation">
                <div class="app-adj-info-group">
                    <div class="app-adj-flex">
                        <div class="app-adj-info-child-group">
                            <label for="privilegeType">License Privilege</label>                
                        </div>
                        <div class="app-adj-info-child-group">                
                            <div class="statusTextFlex">
                                <img v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.privilegeStatus == 'Suspended'" class="active-icon" src="static/status-not-active.png" alt="Icon">
                                <img v-else class="active-icon" src="static/status-active.png" alt="Icon">
                                <span for="statusText">{{ adjudicationLicenseInfo.adjudicationLicenseInformation.privilegeStatus }}</span>  
                            </div>               
                        </div>
                        <div class="app-adj-info-child-group" v-if="!adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails && adjudicationLicenseInfo.adjudicationLicenseInformation.suspensions.length > 0">
                            <button class="showMoreText" role="button" alt="" @click="isSubTabActive(adjudicationLicenseInfo.adjudicationLicenseInformation)">{{adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails ? 'Less':'Details' }}</button>
                        </div>  
                    </div>
                    <div class="app-adj-flex" v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails && adjudicationLicenseInfo.adjudicationLicenseInformation.suspensions.length > 0" >
                        <div class="app-adj-info-child-desc-group">    
                            <label for="suspensionDescription">Suspension Description</label>                
                        </div>
                        <div class="app-adj-info-child-grid-group">
                            <label for="suspensionEffectiveDate">Suspension Effective Date</label>    
                        </div>
                        <div class="app-adj-info-child-grid-group">
                            <label for="suspensionStatus">Suspension Status</label> 
                        </div>
                    </div>  
                    <div class="app-adj-info-group"  v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails">
                        <div class="app-adj-info-row" v-for="(suspensionInfo, i) in adjudicationLicenseInfo.adjudicationLicenseInformation.suspensions" :key="i">
                            <div class="app-adj-flex">
                                <div class="app-adj-info-child-desc-group">    
                                    <span for="suspensionDescriptionText">{{suspensionInfo.suspensionDescription}}</span>
                                </div>
                                <div class="app-adj-info-child-grid-group-text">
                                    <span for="suspensionEffectiveDateText">{{suspensionInfo.suspensionEffectiveDate}}</span>
                                </div>
                                <div class="app-adj-info-child-grid-group-text">
                                    <span for="suspensionStatusText">{{suspensionInfo.suspensionStatus}}</span>
                                </div>
                            </div>      
                        </div>
                    </div>
                    <div class="app-adj-flex">
                        <div class="app-adj-info-child-group" v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails">
                            <button class="showMoreText" role="button" alt="" @click="isSubTabActive(adjudicationLicenseInfo.adjudicationLicenseInformation)">{{adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails ? 'Less':'Details' }}</button>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <!-- Commercial License Info -->
        <div class="app-adj-info" v-if="adjudicationCommercialLicenseInfo"> 
            <div class="app-adj-info-row" v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation">
                <div class="app-adj-info-group">
                    <div class="app-adj-flex">
                        <div class="app-adj-info-child-group">
                            <label for="privilegeType">Commercial License Privilege  </label>               
                        </div>
                        <div class="app-adj-info-child-group">
                            <span>
                                <div class="statusTextFlex">
                                    <img v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.privilegeStatus == 'Suspended'" class="active-icon" src="static/status-not-active.png" alt="Icon">
                                    <img v-else class="active-icon" src="static/status-active.png" alt="Icon">
                                    <span for="statusText">{{ adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.privilegeStatus }}</span>  
                                </div>
                            </span>
                        </div>
                        <div class="app-adj-info-child-group"  v-if="!adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails && adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.suspensions.length > 0">
                            <button class="showMoreText" role="button" alt="" @click="isSubTabActive(adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation)">{{adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails ? 'Less':'Details' }}</button>
                        </div>  
                    </div>
                    <div class="app-adj-flex" v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails && adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.suspensions.length > 0" >
                        <div class="app-adj-info-child-desc-group">    
                            <label for="suspensionDescription">Suspension Description</label>                
                        </div>
                        <div class="app-adj-info-child-grid-group">
                            <label for="suspensionEffectiveDate">Suspension Effective Date</label>    
                        </div>
                        <div class="app-adj-info-child-grid-group">
                            <label for="suspensionStatus">Suspension Status</label>                
                        </div>
                    </div> 
                    <div class="app-adj-info-group"  v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails">
                        <div class="app-adj-info-row" v-for="(suspensionInfo, i) in adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.suspensions" :key="i">
                            <div class="app-adj-flex">  
                                <div class="app-adj-info-child-desc-group" >    
                                    <span for="suspensionDescriptionText">{{suspensionInfo.suspensionDescription}}</span>
                                </div>
                                <div class="app-adj-info-child-grid-group-text" >
                                        <span for="suspensionEffectiveDateText">{{suspensionInfo.suspensionEffectiveDate}}</span>
                                </div>
                                <div class="app-adj-info-child-grid-group-text" >
                                    <span for="suspensionStatusText">{{suspensionInfo.suspensionStatus}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="app-adj-flex">
                        <div class="app-adj-info-child-group" v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails">
                            <button class="showMoreText" role="button" alt="" @click="isSubTabActive(adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation)">{{adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails ? 'Less':'Details' }}</button>
                        </div>  
                    </div>
                </div>
            </div>
        </div>

        <!-- Registration Info -->
        <div class="app-adj-info" v-if="adjudicationRegistrationInfo"> 
            <div class="app-adj-info-row" v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation">
                <div class="app-adj-info-group">
                    <div class="app-adj-flex">
                        <div class="app-adj-info-child-group">
                            <label for="privilegeType">Registration Privilege</label>                
                        </div>
                        <div class="app-adj-info-child-group">                
                            <div class="statusTextFlex">
                                <img v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.privilegeStatus == 'Suspended'" class="active-icon" src="static/status-not-active.png" alt="Icon">
                                <img v-else class="active-icon" src="static/status-active.png" alt="Icon">
                                <span for="statusText">{{ adjudicationRegistrationInfo.adjudicationRegistrationInformation.privilegeStatus }}</span>  
                            </div>               
                        </div>
                        <div class="app-adj-info-child-group" v-if="!adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails && adjudicationRegistrationInfo.adjudicationRegistrationInformation.suspensions.length > 0">
                            <button class="showMoreText" role="button" alt="" @click="isSubTabActive(adjudicationRegistrationInfo.adjudicationRegistrationInformation)">{{adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails ? 'Less':'Details' }}</button>
                        </div>  
                    </div>
                    <div class="app-adj-flex" v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails && adjudicationRegistrationInfo.adjudicationRegistrationInformation.suspensions.length > 0" >
                        <div class="app-adj-info-child-desc-group">    
                            <label for="suspensionDescription">Suspension Description</label>                
                        </div>
                        <div class="app-adj-info-child-grid-group">
                            <label for="suspensionEffectiveDate">Suspension Effective Date</label>    
                        </div>
                        <div class="app-adj-info-child-grid-group">
                            <label for="suspensionStatus">Suspension Status</label> 
                        </div>
                    </div>  
                    <div class="app-adj-info-group"  v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails">
                        <div class="app-adj-info-row" v-for="(suspensionInfo, i) in adjudicationRegistrationInfo.adjudicationRegistrationInformation.suspensions" :key="i">
                            <div class="app-adj-flex">
                                <div class="app-adj-info-child-desc-group">    
                                    <span for="suspensionDescriptionText">{{suspensionInfo.suspensionDescription}}</span>
                                </div>
                                <div class="app-adj-info-child-grid-group-text">
                                    <span for="suspensionEffectiveDateText">{{suspensionInfo.suspensionEffectiveDate}}</span>
                                </div>
                                <div class="app-adj-info-child-grid-group-text">
                                    <span for="suspensionStatusText">{{suspensionInfo.suspensionStatus}}</span>
                                </div>
                            </div>      
                        </div>
                    </div>
                    <div class="app-adj-flex">
                        <div class="app-adj-info-child-group" v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails">
                            <button class="showMoreText" role="button" alt="" @click="isSubTabActive(adjudicationRegistrationInfo.adjudicationRegistrationInformation)">{{adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails ? 'Less':'Details' }}</button>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!adjudicationLicenseInfo.adjudicationLicenseInformation && !adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation && !adjudicationRegistrationInfo.adjudicationRegistrationInformation">
            <SystemAlert/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as COMMONS from '../../store/_commons' 
import SystemAlert from '@/components/SystemAlert'
export default {
   name : 'Adjudication',
   data () {
       return {
         isActive: [],
         showDiv: false // Initialize the boolean variable
       }
    },

    components: {
        SystemAlert,
    },

    computed: {
       ...mapGetters({
        adjudicationLicenseInfo: COMMONS.GUEST_ADJUDICATION_LICENSE_INFO,
        adjudicationCommercialLicenseInfo: COMMONS.GUEST_ADJUDICATION_COMMERCIAL_LICENSE_INFO,
        adjudicationRegistrationInfo: COMMONS.GUEST_ADJUDICATION_REGISTRATION_INFO,
       }),
    },

    methods: {
        isSubTabActive(isActive) {
            this.$set(isActive, 'showDetails', !isActive.showDetails);
        },
    }
}
</script>

<style scoped lang="scss">
    .app-adj-info-row {
        margin: 5px 0px 10px 0px;
        border-bottom: 1px solid #F2F2F2;
        span, label {
            font-size: 1rem;
        }
        .app-adj-flex {
            display: flex;
            gap: 0rem 2rem; 
            .app-adj-info-child-group {
                width: 265px;
                // min-width: 225px;
                // max-width: 230px;
                padding: 1rem;
                .app-icon {
                    // padding: 10px;
                    margin-right: 5px;
                    filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                    vertical-align: text-bottom;
                }
                .statusText {
                    margin: 2px;
                    vertical-align: text-bottom;
                }
                .statusTextFlex {
                    display: flex;
                    vertical-align: text-bottom;
                    margin-top: 5px;
                }
            }
            .app-adj-info-child-grid-group {
                width: 265px;
                .app-icon {
                    margin-right: 5px;
                    filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                    vertical-align: text-bottom;
                }
                .statusText {
                    margin: 2px;
                    vertical-align: text-bottom;
                }
                .statusTextFlex {
                    display: flex;
                    vertical-align: text-bottom;
                    margin-top: 5px;
                    font-size: large;
                }
            }
            .app-adj-info-child-desc-group {
                width: 365px;
                padding-left: 1rem;
                .app-icon {
                    margin-right: 5px;
                    filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                    vertical-align: text-bottom;
                }
                .statusText {
                    margin: 2px;
                    vertical-align: text-bottom;
                }
                .statusTextFlex {
                    display: flex;
                    vertical-align: text-bottom;
                    margin-top: 5px;
                }
            }

            .app-adj-info-child-grid-group-text {
                width: 265px;
                .app-icon {
                    margin-right: 5px;
                    filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                    vertical-align: text-top;
                }
                .statusText {
                    margin: 2px;
                    vertical-align: text-bottom;
                }
                .statusTextFlex {
                    display: flex;
                    vertical-align: text-bottom;
                    margin-top: 5px;
                }
            }
        }
    }
    .active-icon {
        width: 25px;
        height: 25px;
        vertical-align: middle;
        padding-right:5px; 
        padding-bottom:5px;
    }
    .subTabCaret {
        text-align: right;
        position: absolute;
        right: 10%;
    }
    .subtab-icon {
        height: 25px;
        width: 25px;
    }
    .showMoreText {
        cursor: pointer;
    }

    .app-adj-info-row:nth-child(odd) {
        background-color: #F2F2F2;
    }

    @media only screen and (max-width: 600px) {
        .app-adj-info-row .app-adj-flex .app-adj-info-child-group {
            min-width: 155px;
        }
        .app-adj-info-child-group {
            span {
                word-wrap: break-word;
            }
        }
        .subTabCaret {
            width: 120px;
            position: static;
        }
        .app-adj-flex  {
            flex-wrap: wrap;
        }

        .app-adj-info-child-desc-group {
            width: 240px !important;
            padding-left: 0rem;
        }
        .app-adj-info-child-grid-group-text {
            padding-left: 1rem;
            width: 165px;
        }

        .app-adj-info-child-grid-group {
            padding-left: 1rem;
        }
    }
    @media only screen and (min-width: 600px) and (max-width: 1135px) {
        .app-adj-info-row .app-adj-flex .app-adj-info-child-group {
            width: 225px;
        }
        .subTabCaret {
            position: static;
        }
        .app-adj-flex  {
            flex-wrap: wrap;
        }
        .app-adj-info-child-desc-group {
        width: 240px !important;
            padding-left: 0rem;
        }
        .app-adj-info-child-grid-group-text {
            padding-left: 1rem;
            width: 165px;
        }

        .app-adj-info-child-grid-group {
            padding-left: 1rem;
        }
    }
</style>